module.exports = __webpack_public_path__ + "static/media/13.1d8e5ada.png";